import React from 'react';
import { motion } from 'framer-motion';
export function Guarantee() {
  return <section className="py-20 px-4 bg-white" data-id="element-105">
      <div className="max-w-3xl mx-auto" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-crema p-10 md:p-16 rounded-3xl border-2 border-dorado/20 shadow-lg text-center relative overflow-hidden" data-id="element-107">
          {/* Decorative background circle */}
          <div className="absolute -top-20 -right-20 w-64 h-64 bg-dorado/5 rounded-full blur-3xl pointer-events-none" data-id="element-108" />

          <div className="text-6xl mb-6 relative z-10" data-id="element-109">🛡️</div>

          <h2 className="text-3xl md:text-4xl font-bold text-oscuro mb-8 relative z-10" data-id="element-110">
            Garantía 7 días sin preguntas
          </h2>

          <div className="text-lg md:text-xl text-gray-700 space-y-4 mb-8 relative z-10 leading-relaxed" data-id="element-111">
            <p data-id="element-112">Abrí los 12 Tomos. Revisá los 6 Bonus.</p>
            <p data-id="element-113">Usá los Ebooks Élite en tu clase.</p>
            <p className="font-bold text-terracota mt-6" data-id="element-114">
              Si no es lo que esperabas →<br data-id="element-115" />
              100% de devolución.
            </p>
            <p className="font-medium" data-id="element-116">
              Sin preguntas. Sin formularios.
              <br data-id="element-117" />
              Sin drama.
            </p>
          </div>

          <p className="text-sm text-gray-400 font-medium relative z-10 uppercase tracking-wider" data-id="element-118">
            Tasa de devoluciones menor al 2%
          </p>
        </motion.div>
      </div>
    </section>;
}